import React, { useState } from "react";
import axios from "axios";
import logo from "../../assets/images/logo-win.svg";
import loginImage01 from "../../assets/images/registration/registration-steps-image-04.jpg";
import loginImage02 from "../../assets/images/registration/registration-steps-image-05.jpg";
import loginImage03 from "../../assets/images/registration/registration-steps-image-06.jpg";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from "../../Common/LanguageSelector";
import { useLocation } from 'react-router-dom';
import {FaEye,FaEyeSlash} from 'react-icons/fa';
import { useEffect } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import ErrorModal from "../Security/ErrorModal";
import { Endpoints } from "../../Global/Endpoints";
import { useSelector } from "react-redux";
import { de } from "@faker-js/faker";

export const RegistrationFormOne = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const[showPassword,setShowPassword] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const validSSO = useSelector((state) => state.sso.isSSO); 
  const ssoData = useSelector((state) => state.sso.ssoUserData); // Get full SSO user data
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const [logo, setLogo] = useState(null);
  const [showModalsso, setShowModalSSO] = useState(false);
const [loading, setLoading] = useState(false);
const otherData = location.state?.otherData;
  const [form2backsso,setForm2IsSSo]=useState(false)
  const [formData, setFormData] = useState(location.state?.formData || {
    firstName:validSSO? ssoData.FirstName:"",
    lastName:validSSO? ssoData.LastName: "",
    preferredName: "",
    email:"",
    password: "",
    confirmPassword: "",
    agreeTerms: false,
  });
  const [form2Data, setForm2Data]=useState();
  const [form3Data, setForm3Data]=useState();

  const [currentStep, setCurrentStep] = useState(1); // form 1 = step 1
  const totalSteps = 2; 

 


  useEffect(() => {

    const loadLogo = async () => {
      if (isHighmarkPortal) {
        const logoModule = await import("./../../assets/images/highmark/ffb-logo.jpg");
        setLogo(logoModule.default);
      } else {
        const logoModule = await import("./../../assets/images/win/logo-win.svg");
        setLogo(logoModule.default);
      }
    };

    loadLogo();
  }, [ssoData]);

 


  useEffect(() => {

    const loadLogo = async () => {
      if (isHighmarkPortal) {
        const logoModule = await import("./../../assets/images/highmark/ffb-logo.jpg");
        setLogo(logoModule.default);
      } else {
        const logoModule = await import("./../../assets/images/win/logo-win.svg");
        setLogo(logoModule.default);
      }
    };

    loadLogo();
  }, [ssoData]);

  useEffect(() => {
    // Check and log the exact structure of location.state
   
    if(location.state?.form2Data){
      setForm2Data(location.state.form2Data);
    }
    if(location.state?.form3Data){
      setForm3Data(location.state.form3Data)
    }
    if (location.state && location.state.formData1 && location.state.formData1.formData) {
      setFormData(location.state.formData1.formData);
    } else if (location.state?.formData1) {
      setFormData(location.state.formData1);
    } 
    else if (location.state?.formData) {
      setFormData(location.state.formData);
    }
    else if(location.state?.formData1!=undefined){
      if(location.state?.formData1.combinedProviderData)
      {
        setFormData(location.state.formData1.combinedProviderData);
      }
    }
    
      else {
      console.log("No formData passed to form1.");
    }
  }, [location.state]);

  const [errors, setErrors] = useState({});
  const [apiMessage, setApiMessage] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
  setFormData((formData)=>({
    ...formData,
    [id]: type === "checkbox" ? checked : value,
  }));
  if (id === "email") {
    setApiMessage("");
  }

  // Clear API message when the checkbox is interacted with
  if (id === "agreeTerms") {
    setApiMessage("");
  }
  // Clear the error message for agreeTerms if checked
  if (id === "agreeTerms" && checked) {
    setErrors((prevErrors) => ({
      ...prevErrors,
      agreeTerms: "", // Clear the error
    }));
  }
}

//Toggle Funtion for password visibility.
const togglePasswordVisibility = () => {
  setShowPassword((prevShowPassword) => !prevShowPassword);
};

const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]{2,}\.([A-Za-z0-9-]{2,})(?:\.([A-Za-z0-9-]{2,}))?$/;

// Function to validate email
function validateEmailRegex(email) {
  const match = email.match(emailRegex);

  if (match) {
    // Get the captured domain parts
    const domainParts = match.slice(1);

    // Ensure the domain parts are unique
    const uniqueDomains = new Set(domainParts);

    // Return true if the size of unique domains matches the number of domain parts
    return uniqueDomains.size === domainParts.length;
  } else {
    return false; // Does not match regex pattern
  }
}

 useEffect(() => {
 if (ssoData?.Portal === "Highmark") {
    if (!ssoData.FirstName || !ssoData.LastName) {
      setModalMessage("We are unable to connect you to the patient portal. Please call customer support for assistance.");
      setShowModalSSO(true);
    }
  }
}, [validSSO]);

        const handleModalOkaySSO = () => {
  setShowModalSSO(false); 
  if (ssoData?.Portal === "Highmark") {
   if (ssoData.domainInfo === "MyHighmarkIEL") {
          // If first/last name are present, do SSO redirect
          if (!ssoData.FirstName || !ssoData.LastName) {
            window.location.href = "https://auth.highmark.com/home?bmctx=631B249BF72C0BFF3661DEAAA9886192379CFE673ED1137D17410C3D2C757F8F6BCD8A3C1908273832F824E9E115FDCA6390AECEE064155A352EF8CEB28AA4DE&password=secure_string&respCookies=Secure;httponly;SameSite%3DNone;&contextType=external&miscCookies=Secure;httponly;SameSite%3DNone;&ssoCookie=Secure;httponly;SameSite%3DNone;&username=string&challenge_url=https:%2F%2Fauth.highmark.com%2F&request_id=-5676144048537218152&authn_try_count=0&locale=en_US&resource_url=https%253A%252F%252Fauth.highmark.com%252Fhmkoauth%252FuserConsent.jsp%253Fstate%253DZXBBOEhrOHRZdk0xT1dFNHZyT2VVZz09fmNjdGlucEFqSy91MEhISG9WdzNQOG1COHIyWVc0ckxsVEkwbmszT0NzN3E3MTFSemp1SW5pWFlUT21TY3hEeEVSdFFCWHQySURMaGU5MmxvTk05OHQvUUhCZW9kMWFqRzY4MFJuY3pCV2FZSk5QTzhTcTZGK05ubWtpOWxYWGRzVThPQlBuTWFiV1kweCtGVzJna3NZQkVMa2hRN25kY3hGWGRNYWRBZUpyWWFsSjFZMy96aHpvVmVrdEZSYjMzNm5PM2x4V3p5Zkg5azdGamtLUzYwaTlSeUNEZDBsV0hhUW9nTUVFLyt4MjIyWlBXdG9NelNQZkdJSWI3Y0VRM1MzcGEwdTI0U3J0Z1hoYUxYOGFlQnNRcStrVDBBazFYZkx3a0V6bW53Y0cyWWd1US8zZEVOcXBubXZGSERSRlJPbFUyZ0R2QjBQdFZtaU9RUkNBVU5KVDBFbmpLVnNRNllOYXBsNHBVY0hFWnpsQ0d4VDlzU3lSalpLd25UMjl5TW1pWmhCdDFCcUZ1VEg5VWRQTlgwc2lJdnpiZnovb3kvUG15dXoxMUN1MkE9%2526scopes%253Dopenid%252Boffline_access%252Bprofile%252Bresource.READ%252Bmember.external.read-only%252Bmember.external.update%2526client_id%253D4346795-5572-b394-577336f656c61466858347a656c773d3d";
          return;
          }
        } else if (ssoData.domainInfo === "allmyhealth") {
          if (!ssoData.FirstName || !ssoData.LastName) {
            window.location.href = "https://auth.allmyhealth.com/home?bmctx=631B249BF72C0BFF3661DEAAA98861924F2730C2597459EC902D19660439EBE89CF838BB360E94490B14E14E5931CDF0&password=secure_string&respCookies=Secure;httponly;SameSite%3DNone;&contextType=external&miscCookies=Secure;httponly;SameSite%3DNone;&ssoCookie=Secure;httponly;SameSite%3DNone;&username=string&challenge_url=https:%2F%2Fauth.allmyhealth.com%2F&request_id=-1611346045285673224&authn_try_count=0&locale=en_US&resource_url=https%253A%252F%252Fauth.allmyhealth.com%252Fhmkoauth%252FuserConsent.jsp%253Fstate%253DS3BnKzArUi9lNnk2T0UvaXU3L1NpZz09fklpZEY0YU9ySUdUc3F2elc5K3dEMmpqeVo5WVd3N1k0TXZmaFZvMW5Kd0lHRHoxbVI4WG9HdjVOQjVXMzg0NUw2ZFB1QXlGUWZ1emkxV29jS2pibTRZeHhpdzc0aFkrdFRDN1dCbUc5azdIVWozYlpDWjVkQWlXTDQ1dHlsYldjWGtTbDB6cWMvSkdKcExNYUhrZTJyZGs4US9rYWNFNnBUQy9KSnFSaG9KM1pWc2plY0RaTGl2MjF6WEp3Zk1SMkwwWEpGdFdTWTlkZlhUbDRVYW85TlpBQ3FRRkRVeTdOUm5QS1dKM0pJcnVOS2tSOXd6R2gyekoxeWJoamRKdWJ4eWtKd1hta25EK1kvaXNTaFFtTDlIaVI3cGJWQ0hMaHAxNUtacmE1UnhmUTFuQmlhMFVoelo4bU1QOWpvanpRR2ovNVJEc1U1aU9Kc3FLemhLUDZCMG56R0NHaUdNOVBsSVJlcXp3dnBtV0cxVjI5b3M5UXJwajN2a2ttcmNZOFd1UzFuM25UMThuRFhnNTVQTjdnS09QZWViUTVIbzRtUmFiQlJDdERGUDg9%2526scopes%253Dopenid%252Boffline_access%252Bprofile%252Bresource.READ%252Bmember.external.read-only%252Bmember.external.update%2526client_id%253D7a2b6d4-d556-8715-67a4b47694e313059724464496a773d3d";
            return;
          }
          }
        }


  }

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName){ newErrors.firstName = "First Name is required.";
    } else if (formData.firstName.length > 50) {
    newErrors.firstName = "First Name must be 50 characters or less.";
     }
    if (!formData.lastName){ newErrors.lastName = "Last Name is required.";
    } else if (formData.lastName.length > 50) {
        newErrors.lastName = "Last Name must be 50 characters or less.";
      }

    if (formData.preferredName && formData.preferredName.length > 100) {
        newErrors.preferredName = "Preferred Name must be 100 characters or less.";
      }
     else if (formData.email.length > 100) {
        newErrors.email = "Email must be 100 characters or less.";
      }

    if (!formData.email) {
      newErrors.email = "Email is required.";
    } else if (!validateEmailRegex(formData.email)) {
      newErrors.email = "Email address is invalid.";
    }
    if (!formData.agreeTerms) {
      newErrors.agreeTerms = "Please agree to the terms and conditions.";
    }
    if(!(validSSO ||form2backsso))
    {
      if (!formData.password) {
        newErrors.password = "Password is required.";
      } else if (formData.password.length < 8) {
        newErrors.password = "Password must be at least 8 characters.";
      } else if (!/(?=.*[0-9])/.test(formData.password)) {
        newErrors.password = "Password must contain at least one number.";
      } else if (!/(?=.*[!@#$%^&*])/.test(formData.password)) {
        newErrors.password = "Password must contain at least one special character.";
      } else if (!/(?=.*[a-z])/.test(formData.password)) {
        newErrors.password = "Password must contain at least one lowercase letter.";
      } else if (!/(?=.*[A-Z])/.test(formData.password)) {
        newErrors.password = "Password must contain at least one uppercase letter.";
      }
          // Check if confirmPassword is empty
      if (!formData.confirmPassword) {
        newErrors.confirmPassword = "Confirm Password is required.";
      } else if (formData.password && formData.password !== formData.confirmPassword) {
        newErrors.confirmPassword = "Passwords do not match.";
      }
    if (!formData.agreeTerms) {
        newErrors.agreeTerms = "Please agree to the terms and conditions.";
      }
    }
    
    return newErrors;
  };
  const validateEmail = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        Endpoints.validateemail,
        null,
        {
          params: { _Params: JSON.stringify({ EmailID: formData.email, DeviceType: "PatientPortal", }) },
        }
      );
      
      // Check the Result to determine next steps
    if (response.data.Result === 1) {
      debugger
        return true; // Email is available
      } else {
        if (isHighmarkPortal) {
    setModalMessage("The email address you entered already exists in our system. Please enter a different email address.");
  } else {
    setModalMessage(response.data.Message);
  }
  setShowModal(true);
  return false; // Email already exists
      }
    } catch (error) {
      console.error("Error validating email:", error);
      setApiMessage("An error occurred while validating the email.");
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length === 0) {
      const emailExists = await validateEmail();
      if (emailExists) {
        // Proceed with form submission if email is valid
        console.log("Form submitted:", formData);
        console.log("Navigating to /registrationFormTwo");
        console.log(form2Data);
        if(form2Data==null || form2Data == undefined){
          navigate("/registration-form-two", { state: {formData,validSSO,ssoData} });
        }
        if(form2Data!=undefined && form2Data!=null && form3Data ==null && form3Data==undefined){
          navigate("/registration-form-two", { state: {formData,form2Data} });
        }
        if(form3Data!=null && form2Data!=undefined && form2Data!=undefined && form2Data!=null ){
          navigate("/registration-form-two", { state: {formData,form2Data,form3Data,otherData:{...otherData}} });
        }
      } 
    } else {
      setErrors(validationErrors);
    }
  };
 const handleBack = () => {
    navigate("/login");
  };
  const capitalizeFirstLetter = (value) => {
  if (!value) return value;
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};

  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    
    if (myCarousel) {
        new window.bootstrap.Carousel(myCarousel, {
          interval: 5000, // Set interval in milliseconds
        });
      }
  }, []);

   if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }
  return (
    <>
      <header>
        <nav className="navbar navbar-expand-lg container-fixed">
          <a className="navbar-brand" href="#">
          {isHighmarkPortal ? 
            <img src={logo} alt="Logo" className="logo brand-logo" />
          : 
            <img src={logo} alt="Logo" className="logo brand-logo" />
          }            
          </a>
        </nav>
      </header>
      
      <div className="registration-block-main">
        {/* left carousel start */}
        <div className="registration-image-wrapper">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                <img src={loginImage01} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage02} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage03} alt="" className="registration-image" />
              </div>
            </div>
          </div>
        </div>
        {/* left carousel end */}
        
        {/* registration right form area start */}
        <div className="registration-form-main">
          <div className="registration-form">
           {!isHighmarkPortal && (
              <>
                <h3 className="page-heading-bold text-center">{t('welcome')}</h3>
                <p>{t('desc')}</p>
              </>
            )}
            <div className="registration-process-form-wrapper mt-5">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label
                    htmlFor="firstName"
                    className="form-label win-form-label mandatory"
                  >
                    {t('firstname')}
                  </label>
                  <input
                    type="text"
                    className="form-control win-form-control mobile-view"
                    id="firstName"
                    value={isHighmarkPortal? capitalizeFirstLetter(formData.firstName) :formData.firstName}
                    onChange={handleChange}
                    maxLength="50"
                    aria-describedby="firstNameError"
                    autoComplete="off"
                    readOnly={validSSO}
                  />
                  {errors.firstName && (
                    <div id="firstNameError" className="form-field-error-message">
                      {errors.firstName}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="lastName"
                    className="form-label win-form-label mandatory"
                  >
                    {t('lastname')}
                  </label>
                  <input
                    type="text"
                    className="form-control win-form-control mobile-view"
                    id="lastName"
                    value={isHighmarkPortal? capitalizeFirstLetter(formData.lastName): formData.lastName}
                    onChange={handleChange}
                    maxLength="50"
                    aria-describedby="lastNameError"
                    autoComplete="off"
                    readOnly={validSSO}
                  />
                  {errors.lastName && (
                    <div id="lastNameError" className="form-field-error-message">
                      {errors.lastName}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="preferredName"
                    className="form-label win-form-label"
                  >
                    {t('preferredname')}
                  </label>
                  <input
                    type="text"
                    className="form-control win-form-control mobile-view"
                    id="preferredName"
                    value={formData.preferredName}
                    onChange={handleChange}
                    maxLength="100"
                    aria-describedby="preferredNameError"
                    autoComplete="off"
                  />
                  {errors.preferredName && (
                    <div id="preferredNameError" className="form-field-error-message">
                      {errors.preferredName}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="email"
                    className="form-label win-form-label mandatory"
                  >
                    {t('emailaddress')}
                  </label>
                  <input
                    type="text"
                    className="form-control win-form-control mobile-view"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    maxLength="100"
                    aria-describedby="emailError"
                    autoComplete="off"
                    // readOnly={validSSO}
                  />
                  {errors.email && (
                    <div id="emailError" className="form-field-error-message">
                      {errors.email}
                    </div>
                  )}
                </div>
                {!(validSSO || form2backsso)&& ( 
                   <div className="mb-3">
                <label htmlFor="password" className="form-label win-form-label mandatory">
                 {t('password')}
              </label>
      <div className="position-relative">
        {/* Password Input */}
        <input
          type={showPassword ? "text" : "password"} // Conditionally change input type
          className="form-control win-form-control mobile-view"
          id="password"
          value={formData.password}
          onChange={handleChange}
          aria-describedby="passwordError"
          maxLength={50}
          autoComplete="off"
          style={{ paddingRight: "2.5rem" }} // Add padding for the icon  
          readOnly={validSSO}
        />
        {/* Eye Icon Inside Textbox */}
        <span 
          className="position-absolute top-50 end-0 me-4 translate-middle-y pe-2" 
          onClick={togglePasswordVisibility} 
          style={{ cursor: 'pointer' }}
        >
          {showPassword ? <FaEye /> : <FaEyeSlash />} {/* Show FaEyeSlash by default */}
        </span>
      </div>
      {errors.password && (
        <div id="passwordError" className="form-field-error-message">
          {errors.password}
        </div>
      )}
    </div>)}
    {!(validSSO || form2backsso)  && (
                <div className="mb-3">
                  <label
                    htmlFor="confirmPassword"
                    className="form-label win-form-label mandatory"
                  >
                    {t('confirmpassword')}
                  </label>
                  <input
                    type="password"
                    className="form-control win-form-control mobile-view"
                    id="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    aria-describedby="confirmPasswordError"
                    maxLength={50}
                    autoComplete="off"
                    readOnly={validSSO}
                  />
                  {errors.confirmPassword && (
                    <div id="confirmPasswordError" className="form-field-error-message">
                      {errors.confirmPassword}
                    </div>
                  )}
                </div>
    )}
                <div className="mb-3 form-check win-form-check">
                  <input
                    type="checkbox"
                    className="form-check-input radio-btn win-form-check-input mobile-view"
                    id="agreeTerms"
                    checked={formData.agreeTerms}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label checkbox-radio-text"
                    htmlFor="agreeTerms"
                  >
                    {isHighmarkPortal ? (
                      <>
                        I agree to the <a href="https://managed.winfertility.com/content-library/nobrand/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and  <a href="https://managed.winfertility.com/content-library/nobrand/terms-conditions/" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
                        {' '}including collection of sensitive personal information and possible disclosure of my information to my employee.
                      </>
                    ) : (
                      <>
                        I agree to the <a href="https://winfertility.com/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="https://winfertility.com/terms-conditions/" target="_blank" rel="noopener noreferrer">Terms and Conditions</a> 
                        {' '} including collection of sensitive personal information and possible disclosure of my information to my employee.
                      </>
                    )}
                  </label>
                  {errors.agreeTerms && (
                    <div className="form-field-error-message">
                      {errors.agreeTerms}
                    </div>
                  )}
                </div>
                <div className="mb-3">

                {isHighmarkPortal ? (
                  <>
                  <div className="pagination-wrapper mt-5">
                    <div></div>
                    <span className="me-3">{currentStep} of {totalSteps}</span>
                    <button type="submit" className="next-btn" onClick={handleSubmit}></button>
                </div>
               </>

              ) : (
                 <>
                  <button className="win-btn-secondary  mobile-view me-3 mb-2 mb-md-0" onClick={handleBack} type="button">{t('back')}</button>
                  <button type="submit" className="win-btn-primary mt-4"onClick={handleSubmit}>{t('nextbutton')}</button>
                 </>
                
                )}
                  </div>
              </form>
              {/* {apiMessage && <div className="form-field-error-message">{apiMessage}</div>} */}
            </div>
          </div>
        </div>
        {/* <div> <LanguageSelector /></div> */}
        {/* registration right form area end */}
      </div>
      <ErrorModal show={showModal} message={modalMessage} onClose={() => setShowModal(false)}  />
        <ErrorModal
    show={showModalsso}
    message={modalMessage}
    //onOkay={handleModalOkaySSO}
    onClose={() => handleModalOkaySSO()}

  />
    </>
  );
};

export default RegistrationFormOne;
